// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1585":"0710a6e76344d2a6","4583":"697a85a8eef32d99"}[chunkId] + ".css";
};